/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function receivers(instance) {
	return {
		/**
		 * @param {number} receiverId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (receiverId, config = {}) => {
			return instance.get(`receivers/${receiverId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`receivers${params}`, config)
		},

		/**
		 * @param {number} receiverId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (receiverId, body, config = {}) => {
			return instance.put(`receivers/${receiverId}`, body, config)
		},

		/**
		 * @param {number} receiverId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (receiverId, config = {}) => {
			return instance.delete(`receivers/${receiverId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('receivers', body, config)
		},

		/**
		 * @param {number} receiverId
		 * @param {number} marketId
		 * @param {number} countryId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			pageNumber,
			pageSize,
			receiverId,
			marketId,
			countryId,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const receiverParam = receiverId ? `receiverId=${receiverId}&` : ''
			const marketParam = marketId ? `marketId=${marketId}&` : ''
			const countryParam = countryId ? `countryId=${countryId}&` : ''

			return instance.get(
				`receivers/filter?${params}${receiverParam}${marketParam}${countryParam}`,
				config
			)
		}
	}
}
